<template>
  <div> 
    <div class="panel panel-warning" style="margin-left: 10px;">
        <div class="panel-heading">
            <h3 class="panel-title"><span style="font-weight: bold;">Marcas</span></h3>
        </div>
        <div class="panel-body panel-body-vue" >            
            <ul class="carBrandContainer"    >        
                <li v-for='itemsDetail in ItemsDetails'>
                    <div>                                                
                        <router-link v-bind:to="'/view/0/brand/' + itemsDetail.id" tag='a' > <span >{{itemsDetail.name}} <span >({{itemsDetail.count}})</span> </span></router-link>
                        <!--<a v-bind:href="'/view/0/brand/' + itemsDetail.id"> <span >{{itemsDetail.name}} <span >({{itemsDetail.count}})</span> </span></a>-->
                    </div>
                </li>         
            </ul>
        </div>
    </div>                     
  </div>
</template>

<script>
export default {  
  data: function () {
    return {
      ItemsDetails: [],      
    }
  },
  created: function () {                  

  },
  mounted: function () {                            
    this.getItemsDetails();    
  },
  methods: {
    getItemsDetails: function() {              
        
        this.$http.get('api/getbrandforsalecount').then(response => {   

            this.ItemsDetails = response.body.map(obj =>{                                                                             
                return obj;
            });                                    
                        
            this.gotData = true;                     
        }, response => {            
            //eventBus.$emit('errorMsg',response);
        });
    },      
    GoToUrl: function(id){        
        //this.$router.push('/view');        
    },    
  },
  filters: {

  },
  computed: {      

  },  
}
</script>

<style scoped>
    .carBrandContainer {                   
        list-style: none;        
        margin-left: -35px;
        font-weight: 500;
        font-size: 16px;        
        padding-top: 10px;
    }

    li {
        padding-top: 3px;
    }
    .panel-body-vue {
        padding: 0px;
    }
</style>



// WEBPACK FOOTER //
// CarBrandSideBar.vue?7b83ee9c